import {
    Component,
    ElementRef,
    HostListener,
    Input,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    OnInit,
    ViewChildren,
    QueryList,
    Output,
    EventEmitter,
} from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { EuiUploadedFile } from './models/uploaded-file.model';

@Component({
    selector: 'eui-file-upload',
    templateUrl: './eui-file-upload.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: EuiFileUploadComponent,
            multi: true,
        },
    ],
    styleUrls: ['./styles/eui-file-upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiFileUploadComponent implements ControlValueAccessor, OnInit {
    @Input() progress: number;
    @Input() isMultiple = true;
    @Input() hasProgressBar = true;
    @Input() hasPreview = true;
    @Input() hasPreviewAsImage = true;
    @Input() hasPreviewAsIcon = false;
    @Input() hasTotalSizeDisplayed = true;
    @Input() hasResetButton = true;
    @Input() accept = '*';
    @Input()
    get hasDragArea() { return this._hasDragArea; }
    set hasDragArea(value) { this._hasDragArea = coerceBooleanProperty(value); }
    _hasDragArea = false;

    @Output() drop = new EventEmitter();

    public files: File[] = [];
    public filesTotalSize = 0;
    public randomNumberId = Math.floor(Math.random() * 10000);
    public uploadedFiles: EuiUploadedFile[] = [];
    @ViewChildren('input') viewChildren: QueryList<ElementRef<HTMLInputElement>>;

    @HostListener('change', ['$event.target.files']) emitFiles(fileList: FileList) {
        for (const property in fileList) {
            if (fileList[property] && typeof fileList[property] === 'object') {

                const fileName = fileList[property].name.split('.');
                const fileExtension = fileName[fileName.length - 1];

                if (this.accept.indexOf(fileExtension) !== -1 || this.accept === '*') {
                    this.files.push(fileList[property]);
                }
            }
        }

        this.getTotalSize();
        this.uploadedFiles ? this.onChange([...this.uploadedFiles, ...this.files]) : this.onChange(this.files);
        this.drop.emit();
    }

    ngOnInit() {
        if (this.hasPreviewAsIcon) {
            this.hasPreviewAsImage = false;
        }
    }

    public removeFromList(index: number) {
        this.files = this.files.filter((f, i) => {
            return i !== index;
        });

        if (this.files.length === 0) {
            this.progress = 0;
        }
        this.getTotalSize();
        this.onChange([...this.uploadedFiles, ...this.files]);
        this.writeValue([...this.uploadedFiles, ...this.files]);
    }

    public removeFromUploadedList(index: number) {
        this.uploadedFiles = this.uploadedFiles.filter((f, i) => {
            return i !== index;
        });

        if (this.files.length === 0) {
            this.progress = 0;
        }
        this.getTotalSize();
        this.onChange([...this.uploadedFiles, ...this.files]);
        this.writeValue([...this.uploadedFiles, ...this.files]);
    }

    public getTotalSize() {
        this.filesTotalSize = 0;
        this.files.forEach((f) => {
            this.filesTotalSize += f.size;
        });
    }

    public resetList(event: any) {
        this.files = [];
        this.getTotalSize();
        this.progress = 0;
        this.onChange([...this.uploadedFiles, ...this.files]);
    }

    writeValue(value: any) {
        this.uploadedFiles = value || [];

        if (this.viewChildren) {
            this.viewChildren.first.nativeElement.value = '';
        }
        this.files = [];
    }

    registerOnChange(fn: any) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any) {
    }

    private onChange: any = () => {};

}
